var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureChatDownloadGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.158,
    height: 18.158,
    viewBox: "0 0 18.158 18.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-minimalistic-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M3,15c0,2.539,0,3.808.789,4.6s2.058.789,4.6.789h5.386c2.539,0,3.808,0,4.6-.789s.789-2.058.789-4.6",
    transform: "translate(0 -1.228)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M11.591,3V14.67m0,0,3.591-3.927M11.591,14.67,8,10.742",
    transform: "translate(-0.512 0)",
    fill: "none",
    stroke: "#c8c8c8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureChatDownloadGreyIcon);
export default __webpack_public_path__ + "static/media/secure-chat-download-grey-icon.34eaee4c9558f908712de2b45e9e098a.svg";
export { ForwardRef as ReactComponent };